<!-- @format -->

<template>
	<div class="container">
		<h1 class="flex items-center">
			<base-modal v-show="!loading" ref="createCourseModal">
				<base-form class="w-full" ref="createCourseForm" :form-data="form" @submitted="add"></base-form>
				<template v-slot:modal-button="{ showModal }">
					<button @click="showModal" class="button is-small mr-1">
						<font-awesome-icon icon="plus" />
					</button>
				</template>
			</base-modal> Courses
		</h1>
		<base-course-list @loaded="loading = false" ref="course-list"></base-course-list>
	</div>
</template>

<script>
/** @format */
import CourseFields from '@/fields/courses';

export default {
	name: 'Courses',
	methods: {
		add(payload) {
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving golf course.'});
			this.$store
				.dispatch('courses/add', payload)
				.then((data) => {
					this.$refs['course-list'].refresh();
					this.$refs.createCourseForm.resetFieldValues();
					this.$refs.createCourseModal.closeModal();
					this.$store.dispatch('notification/add', {type: 'success', message: 'Course added successfully.'});
				})
				.finally(() => {
					this.$refs.createCourseForm.submitting = false;
				});
		}
	},

	data() {
		return {
			form: JSON.parse(JSON.stringify(CourseFields)),
			loading: true,
		};
	}
};
</script>
